<template>
  <main class="bg-light" style="padding-block-end: 1in;">



      <!-- Carousel -->
      <div id="carouselExampleIndicators" class="carousel slide w-75 mx-auto mb-5 py-3"  data-bs-ride="carousel" data-bs-interval="4000">
        <!-- Carousel Indicators -->
        <div class="carousel-indicators">
          <button v-for="(slide, index) in slides" :key="index" type="button"
            data-bs-target="#carouselExampleIndicators" :data-bs-slide-to="index" :class="{ active: index === 0 }"
            :aria-current="index === 0 ? 'true' : null" :aria-label="`Slide ${index + 1}`"></button>
        </div>

        <!-- Carousel Slides -->
        <div class="carousel-inner">
          <div v-for="(slide, index) in slides" :key="index" :class="['carousel-item', { active: index === 0 }]">
            <img :src="slide.image" class="d-block carousel-image  w-100" alt="Slide Image"
              style="height: 4in; object-fit: cover;">
            <!-- Centered Caption -->
            <div class="carousel-caption d-flex flex-column justify-content-center align-items-center text-center">
              <div>
                <h1 class="poppins-bold" :class="['animate__animated animate__slow', slide.animationClass]">{{
                  slide.text }}
                </h1>
                <p class="fw-medium" :class="['animate__animated animate__slower', slide.animationClass]" v-if="slide.description">{{
                  slide.description }}</p>
                <div class="d-flex justify-content-center mt-3">
                  
                  <router-link to="/main/croppingcalendar" style="background-color: #306102;" class="btn w-50 text-light fw-bolder animate__animated text-decoration-none animate__slower animate__delay-1s animate__bounceInUp" >
                    Go to Calendar
                  </router-link>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- Controls -->
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
          data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
          data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>

    <!-- Header / Hero -->
    <header class="py-2 ">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-7">
            <h1 class="display-6 fw-bolder mb-3 text-uppercase poppins-extrabold">
              Cropping Calendar
            </h1>
            <p class="fs-5 fw-semibold mb-3">
               Plan, Track & Optimize Your Season
            </p>
            <p class="lead fs-6 text-muted mb-4">
              Generate crop-specific activity schedules, get risk advisories,
              and receive region-based recommendations. Use the Cropping
              Calendar to plan planting windows, track key farm tasks, and make
              data-driven decisions.
            </p>

         <router-link to="/main/croppingcalendar" style="background-color: #306102;" class="btn w-50 text-light fw-bolder animate__animated text-decoration-none animate__slower animate__delay-1s animate__bounceInUp" >
                    Go to Calendar
                  </router-link>

            <p class="mt-4 text-muted small text-center">
              Try the Cropping Calendar to compute monthly activities and
              sequential timelines tailored to your district and crop.
            </p>

            <!-- Partner Logos -->
            <div class="mt-3">
              <p class="text-bolder fs-4 text-center mb-2">Partners</p>
              <div class="d-flex justify-content-center align-items-center gap-3">
                <img 
                  src="../assets/stk/Layer 18.png" 
                  alt="Alliance Bioversity & CIAT" 
                  class="partner-logo img-fluid"
                  style="max-height: 80px;"
                />
                <img 
                  src="../assets/stk/Layer 3.png" 
                  alt="CSIR Ghana" 
                  class="partner-logo img-fluid"
                  style="max-height: 80px;"
                />
              </div>
            </div>
          </div>

          <!-- Right side hero image -->
          <div class="col-lg-5 mt-4 mt-lg-0">
            <div class="hero">
              <img
                src="../assets/New Project(1).png"
                alt="Farm field aerial view"
                class="hero-img"
              />
            </div>
          </div>
        </div>
      </div>
    </header>


    <!-- Features / Quick info -->
    <section id="stats-section" class="container mt-5 mb-5">
    <div class="row gy-4">
      <!-- Notification Card -->
      <div class="col-md-3" v-if="currentNotification">
        <div class="card border-0 shadow-sm notification-card">
          <div class="card-body p-3">
            <div class="d-flex align-items-start mb-2">
              <div class="notification-icon bg-warning text-white me-2">
                <i class="bi bi-bell"></i>
              </div>
              <div class="flex-grow-1">
                <h6 class="fw-bold mb-1">{{ currentNotification.label }}</h6>
                <p class="small text-muted mb-2">{{ currentNotification.description }}</p>
                <p v-if="currentNotification.resolution" class="small text-success mb-0">
                  <i class="bi bi-check-circle me-1"></i>{{ currentNotification.resolution }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Stats Cards -->
      <div
        v-for="(stat, i) in stats"
        :key="i"
        class="col-md-3"
        :class="{ 'col-md-4': !currentNotification }"
      >
        <div class="card border-0 shadow-sm stat-card">
          <div class="card-body text-center p-3">
            <div class="stat-icon" :class="stat.color" style="font-size: 2rem;">
              <i :class="stat.icon"></i>
            </div>
            <div class="stat-number" style="font-size: 2rem;">
              {{ stat.current.toLocaleString() }}
            </div>
            <div class="stat-label" style="font-size: 1rem;">
              {{ stat.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  </main>
</template>
<script>
import axios from 'axios'
export default {
  data() {
    return {
           slides: [
  {
    image: require("../assets/ccdata.jpg"),
    text: "Monthly Calendar",
    animationClass: "animate__bounceInDown",
    buttonText: "Learn More",
    description: "View a 12-month breakdown of recommended activities for your crop and planting date range."
  },
  {
    image: require("../assets/timeline.png"),
    text: "Activity Timeline",
    animationClass: "animate__bounceInDown",
    buttonText: "Get Started",
    description: "Sequential activity timeline including dependencies, start/end dates and step-by-step instructions."
  },
  {
    image: require("../assets/hands.jpg"),
    text: "Risks & Advisories",
    animationClass: "animate__bounceInDown",
    buttonText: "Join Now",
    description: "Get risk assessments and localized advisories (pest, drought, fertiliser guidance) for each activity."
  }
],
stats: [
        { id: "stat5", start: 0, end: 22, current: 0, duration: 2000, icon: "bi bi-person-check", color: "text-dark", label: "Persons" },
        { id: "stat6", start: 0, end: 340, current: 0, duration: 2000, icon: "bi bi-geo-alt", color: "text-danger", label: "Disticts" },
        { id: "stat7", start: 0, end: 18, current: 0, duration: 2000, icon: "fa-solid fa-seedling", color: "text-success", label: "Crop Varieties" },
      ],
      hasAnimated: false,
      notifications: [],
      currentNotification: null,

    }
  },
async mounted() {
  await this.getStats();
  await this.fetchNotifications();

    window.addEventListener("scroll", this.checkScroll);
    window.addEventListener("load", this.checkScroll);

    // also check immediately
    setTimeout(this.checkScroll, 100);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.checkScroll);
    window.removeEventListener("load", this.checkScroll);
  },
  methods: {
    animateValue(stat) {
      let current = stat.start;
      const range = stat.end - stat.start;
      
      const getIncrement = (value) => {
        if (value >= 10000) return 200;
        if (value >= 1000) return 200;
        if (value >= 100) return 20;
        if (value >= 10) return 2;
        return 1;
      };
      
      const increment = stat.end > stat.start ? getIncrement(stat.end) : -getIncrement(stat.end);
      const steps = Math.ceil(range / Math.abs(increment));
      const stepTime = Math.abs(Math.floor(stat.duration / steps));

      const timer = setInterval(() => {
        current += increment;
        if ((increment > 0 && current >= stat.end) || (increment < 0 && current <= stat.end)) {
          current = stat.end;
        }
        stat.current = current;
        if (current === stat.end) {
          clearInterval(timer);
        }
      }, stepTime);
    },
    isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },
    checkScroll() {
      const section = document.getElementById("stats-section");
      if (section && this.isElementInViewport(section) && !this.hasAnimated) {
        this.hasAnimated = true;
        this.stats.forEach((stat) => this.animateValue(stat));
      }
    },
    async getStats() {
      try {
        const response = await axios.get("https://aghub.miphost.com/api/stats");
        const apiStats = response.data;

        const mapping = {
          stat5: apiStats.uniqueVisitors,
          stat6: apiStats.totalDistricts,
          stat7: apiStats.totalCrops,
        };

        // Merge into tats
        this.stats = this.stats.map(stat => ({
          ...stat,
          end: mapping[stat.id] !== undefined ? mapping[stat.id] : stat.end,
          current: stat.start,
        }));

        console.log(this.stats)

      } catch (error) {
        console.log(error);
      }
    },
    async fetchNotifications() {
      try {
        const response = await axios.get("https://aghub.miphost.com/api/cc/notifications/visible");
        this.notifications = response.data;
        if (this.notifications.length > 0) {
          this.currentNotification = this.notifications[0];
        }
      } catch (error) {
        console.log("Error fetching notifications:", error);
      }
    }
  },
};
</script>
<style scoped>
/* Hero styles */
/* .hero {
  position: relative;
  overflow: hidden;
  border-radius: 0.5rem;
} */

/* .hero .overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom right,
    rgba(6, 78, 59, 0.45),
    rgba(3, 37, 65, 0.35)
  );
  z-index: 1;
} */
        .carousel-caption {
            background: rgba(0, 0, 0, 0.4);
            border-radius: 10px;
            padding: 2rem;
            max-width: 80%;
            margin: 0 auto;
        }
        
        .poppins-extrabold {
            font-weight: 800;
            font-size: 2.5rem;
            margin-bottom: 1rem;
        }

        .poppins-bold {
            font-weight: 700;
            font-size: 2rem;
            margin-bottom: 1rem;
        }

        .carousel-image {
  /* filter: grayscale(100%) brightness(0.5); */
  filter: brightness(0.5);
  transition: filter 0.5s ease, transform 0.5s ease;
}
.hero .hero-img {
  width: 100%;
  object-fit: cover;
  display: block;
  /* filter: contrast(0.95) brightness(0.9); */
}

.hero .hero-content {
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.45);
  max-width: 980px;
  width: 100%;
  padding: 1rem;
}

/* Logos grid */
.partner-logo {
  max-height: 64px;
  object-fit: contain;
  opacity: 0.85;
  transition: opacity 0.2s ease, transform 0.15s ease;
}

.partner-logo:hover {
  opacity: 1;
  transform: translateY(-4px);
}

/* Subscribe form */
.subscribe-input:focus {
  box-shadow: none;
  border-color: #0d6efd;
}

.notification-card {
  border-left: 4px solid #ffc107 !important;
}

.notification-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
</style>
